
import { defineComponent, onMounted, reactive, toRefs, ref } from "vue";
import OriginPlasticSource from "./originPlasticSource/originPlasticSource.vue";
import Authentication from "./authentication/authentication.vue";
import PlantPlasticSource from "./plantPlasticSource/plantPlasticSource.vue";
import ProductionSubject from "./productionSubject/productionSubject.vue";
import ProcessTrace from "./processTrace/processTrace.vue";
import {
  getTracePrimaryInfo,
  getCodePrimaryInfo,
} from "../../../api/production";
import { StateType } from "./trace";
import { Router, useRoute, useRouter } from "vue-router";
import { ImagePreview } from "vant";
import {getConfigWeixin} from "../../utils/index"
import wx from "weixin-js-sdk";
const states = {
  dataInfo: {},
  pid: "",
  sid: "",
  dataId: "",
  sortArr: [],
};
export default defineComponent({
  components: {
    OriginPlasticSource,
    Authentication,
    PlantPlasticSource,
    ProductionSubject,
    ProcessTrace,
  },
  setup() {
    const stateData = reactive<StateType>(states);
    const { getTraceInfo, getCodeInfo } = useDatas(stateData);
    const route = useRoute();
    const router = useRouter();
    const card = ref(null);

    onMounted(() => {
      var _hmt:any = _hmt || [] as any;
      (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?c2aa35b4f55dafcc2273b2c518de9e5e";
        var s = document.getElementsByTagName("script")[0]; 
        (s.parentNode as any).insertBefore(hm, s);
      })();
      stateData.sid = route.query.sid as string;
      stateData.pid = route.query.pid as string;
      if ((stateData.sid && stateData.pid) || stateData.sid) {
        getTraceInfo();
      } else if (stateData.pid) {
        getCodeInfo();
      }
    });
    return {
      ...toRefs(stateData),
      ...useEvent(stateData, router),
      card,
    };
  },
});

const useEvent = (state: StateType, router: Router) => {
  const onPayment = (url: string, type: number) => {
    // type：0 网页链接。 1 二维码图片
    if (type == 0) {
      window.open(url);
    } else {
      router.push({
        path: "/showQR",
        query: {
          url,
        },
      });
    }
  };
  const onVerify = () => {
    router.push({
      path: "/verify",
      query: {
        pid: states.pid,
        dataId: states.dataId,
      },
    });
  };
  const onPreviewImg = () => {
    if (!state.dataInfo.productImg) {
      return;
    }

    ImagePreview([state.dataInfo.productImg]);
  };

  return {
    onPreviewImg,
    onVerify,
    onPayment,
  };
};

const useDatas = (state: StateType) => {
  const getTraceInfo = async () => {
    const result: any = await getTracePrimaryInfo({ traceId: state.sid });
    if (result.data.code == 0) {
      state.dataInfo = result.data.data;
      state.dataId = result.data.data.id;
      state.sortArr = result.data.data.sort.split(",");
    }
  };
  const getCodeInfo = async () => {
    const result: any = await getCodePrimaryInfo({ codeId: state.pid });
    if (result.data.code == 0) {
      state.dataInfo = result.data.data;
      state.dataId = result.data.data.id;
      state.sortArr = result.data.data.sort.split(",");
    }
  };
  return {
    getTraceInfo,
    getCodeInfo,
  };
};
